/**
 * Loads the colour swatches for a product card from the product.color-swatch template
 * (see snippets/color-swatch.liquid).
 *
 * A custom element rather than an inline script so it also runs when cards are added with
 * innerHTML (product recommendations, infinite scroll, filters), where inline scripts don't run.
 */
class ProductSwatches extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded) return;
    this.dataset.loaded = 'true';
    this.load();
  }

  async load() {
    try {
      const response = await fetch(this.dataset.url);
      if (!response.ok) throw new Error(response.status);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const container = doc.querySelector('#color-swatch-container');
      if (container) {
        this.innerHTML = `<div class="swatch-wrapper">${container.innerHTML}</div>`;
      }
    } catch (error) {
      console.log('Unable to load colour swatches', error); // eslint-disable-line
    }
  }
}

customElements.define('product-swatches', ProductSwatches);
